import { createFileRoute } from '@tanstack/react-router'
import RoyaltySalesChannelsForm from 'Admin/components/royaltySalesChannels/RoyaltySalesChannelsForm'

import { Guard } from '../-guard'

export const Route = createFileRoute('/admin/royaltySalesChannels')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <RoyaltySalesChannelsForm />
        </Guard>
    ),
})
